/*
 UI COMPONENT: Slider in Infotainment Cards
 ---------------------------------------------------
 Stimulus API in HTML
 ---------------------------------------------------
 data-action="slider#prev"
 data-action="slider#next"
 */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['slides', 'slide', 'prev', 'next']
  static values = {
    imagesDisplay: { type: Number, default: 2 }
  }
  imagesLength
  imageWidth
  scrollIndex = 0
  scroller
  connect() {
    const images = this.slideTargets
    this.imagesLength = images.length
    this.imageWidth = images[0].clientWidth
    this.scroller = this.slidesTarget
    this.scroller.addEventListener('scroll', (event) => this.#scrollHandler(event))

    this.#reset()
  }

  prev() {
    this.scrollIndex = Math.max(this.scrollIndex - this.imagesDisplayValue, 0)
    this.#scroll()
  }

  next() {
    this.scrollIndex = Math.min(this.scrollIndex + this.imagesDisplayValue, this.imagesLength - this.imagesDisplayValue)
    this.#scroll()
  }

  #scroll() {
    this.scroller.scrollTo({
      left: this.scrollIndex * this.imageWidth,
      behavior: 'smooth'
    })
    this.#updateButtonState()
  }

  #scrollHandler(event) {
    this.scrollIndex = Math.round(this.scroller.scrollLeft / this.imageWidth)
    this.#updateButtonState()
  }

  #updateButtonState() {
    this.prevTarget.disabled = this.scrollIndex === 0
    this.nextTarget.disabled = this.scrollIndex >= this.imagesLength - this.imagesDisplayValue
  }

  #reset() {
    this.scroller.scrollTo({
      left: 0,
    })
    this.#updateButtonState()
  }
}
